import { createContext } from 'react';
import { PaymentsEligibilityStatus } from '../commands/paymentLink/PaymentLinksApi';
export const PaymentLinksEligibilityContext = /*#__PURE__*/createContext(PaymentsEligibilityStatus.INELIGIBLE);